import React from 'react';
import './Bio.css';

const Bio = () => {
    return (
        <section className="bio-section">
            <div className="bio-container">
                <h2>BIOGRAPHY</h2>
                <p>
                    KOTTO is the new identity of an artist with a rich history behind the decks. Formerly known as DJ AIK, he’s spent decades immersed in the club scene, shaping unforgettable nights all around the world.
                </p>
                <p>
                    Now producing under his new name, KOTTO channels that global experience into a fresh sonic vision, a fusion of house and melodic house infused with the pulse of Afrobeat and the groove of hip-hop. His music blends deep, hypnotic rhythms with uplifting melodies, crafted for both golden-hour sunsets and peak-time euphoria. Every track tells the story of an artist who’s evolved without losing the heartbeat of the dance floor.
                </p>
                <a
                    href="https://www.dropbox.com/scl/fo/014wvh1y71i5dxgjp970r/AJIgjOAAIE9plTiDhB2O-Dw?rlkey=hh06t20ew303ps5wzcwdwrp4n&e=1&st=m0v7o98e&dl=0"
                    target="_blank"
                    rel="noreferrer"
                    className="btn-primary"
                >
                    DOWNLOAD PRESS KIT
                </a>
            </div>
        </section>
    );
};

export default Bio;
